function AccessControl() {
    var accessMap = new Map();

    return {
        setPermList: function(list) {
            accessMap.clear();
            if (list != null && Array.isArray(list)) {
                list.forEach((item) => {
                    accessMap.set(item, item);
                })
            }
        },
        check: function(access) {
            if (access != null) {
                if (Array.isArray(access)) {
                    for (let i = 0; i < access.length; i++) {
                        if (!accessMap.has(access[i])) return false;
                    }
    
                    return true;
                }
                else {
                    return accessMap.has(access);
                }
            }
            else {
                return false;
            }
        }
    }
}

const AccessManager = new AccessControl();

export default AccessManager;


// WEBPACK FOOTER //
// ./src/core/access/index.js